module.exports = __webpack_public_path__ + "img/nav-header-mobile-engagement@2x.6ec3dfc.webp";